/** @deprecated Use numeric or 'inherit' 1em. */
export const LegacyTablerIconSize = {
    '2xs': 12,
    xs: 14,
    sm: 16,
    md: 18,
    base: 20,
    lg: 24,
    xl: 28,
    '2xl': 32,
    '3xl': 48,
    '4xl': 64,
};
const DEFAULT_STROKE_WIDTH_BY_SIZE = [
    [24, 1.75],
    [28, 1.65],
    [32, 1.5],
    [48, 1.25],
    [64, 1.0],
];
/** Returns default stroke width for a pixel size, snapping between steps. */
export function getDefaultStrokeWidth(size) {
    const first = DEFAULT_STROKE_WIDTH_BY_SIZE[0];
    if (size === 'inherit' || size <= first[0])
        return first[1];
    const last = DEFAULT_STROKE_WIDTH_BY_SIZE[DEFAULT_STROKE_WIDTH_BY_SIZE.length - 1];
    if (size >= last[0])
        return last[1];
    for (let index = 0; index < DEFAULT_STROKE_WIDTH_BY_SIZE.length - 1; index++) {
        const [lowSize, lowWidth] = DEFAULT_STROKE_WIDTH_BY_SIZE[index];
        const [highSize, highWidth] = DEFAULT_STROKE_WIDTH_BY_SIZE[index + 1];
        if (size >= lowSize && size <= highSize) {
            return size <= (lowSize + highSize) / 2 ? lowWidth : highWidth;
        }
    }
    return first[1];
}
//# sourceMappingURL=iconSizing.js.map